import { render, staticRenderFns } from "./InvoiceItemDialog.vue?vue&type=template&id=043540c2&"
import script from "./InvoiceItemDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports